import { option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { TextKey } from '@mews/text-keys';

interface GetAgeCategoryLabelTextKey {
    maximalAge: option.Option<number>;
    minimalAge: option.Option<number>;
}

export const getAgeCategoryLabelTextKey = ({ minimalAge, maximalAge }: GetAgeCategoryLabelTextKey) => {
    let textKey = null;
    if (option.isSome(minimalAge) && option.isNone(maximalAge)) {
        textKey = TextKey.AgeCategoryLowerBounded;
    }
    if (option.isNone(minimalAge) && option.isSome(maximalAge)) {
        textKey = TextKey.AgeCategoryUpperBounded;
    }
    if (option.isSome(minimalAge) && option.isSome(maximalAge)) {
        textKey = TextKey.AgeCategoryLowerAndUpperBounded;
    }
    return option.fromNullable(textKey);
};

export const ageToString = flow(
    option.map((numericAge: number) => numericAge.toString(10)),
    option.getOrElse(() => '')
);
